import { IStyle, Modifier } from "../types";

interface IMinimalNodeStyle {
	f?: number; // bold italic underline strike
	s?: number; // font size
	t?: string; // font family
	c?: string; // color
	b?: string; // bold
	a?: string; // anchor
}

interface IMinimalBlockStyle {
	a?: number; // align; 1 - left, 2 - center, 3 - right
	b?: number; // blockquote; 1
	s?: number; // 1 - h1, ...
}

export function minimizeTextNodeStyle(style: IStyle): IMinimalNodeStyle {
	const formatting =
		style[Modifier.bold] |
		(style[Modifier.italic] << 1) |
		(style[Modifier.underline] << 2) |
		(style[Modifier.strike] << 3);
	const minimal: IMinimalNodeStyle = {};
	if (formatting !== 0) {
		minimal.f = formatting;
	}
	if (style[Modifier.fontSize]) {
		minimal.s = parseInt(style[Modifier.fontSize], 10);
	}
	if (style[Modifier.fontFamily]) {
		minimal.t = style[Modifier.fontFamily];
	}
	if (style[Modifier.color]) {
		minimal.c = style[Modifier.color];
	}
	if (style[Modifier.background]) {
		minimal.b = style[Modifier.background];
	}
	if (style[Modifier.link]) {
		minimal.a = style[Modifier.link];
	}
	return minimal;
}

export function textNodeStyleFromMinimize(minimal: IMinimalNodeStyle): IStyle {
	const result: IStyle = {};
	if (minimal.f) {
		if (minimal.f & 1) {
			result[Modifier.bold] = true;
		}
		if (minimal.f & 2) {
			result[Modifier.italic] = true;
		}
		if (minimal.f & 4) {
			result[Modifier.underline] = true;
		}
		if (minimal.f & 8) {
			result[Modifier.strike] = true;
		}
	}

	if (minimal.s) {
		result[Modifier.fontSize] = minimal.s + "px";
	}
	if (minimal.t) {
		result[Modifier.fontFamily] = minimal.t;
	}
	if (minimal.c) {
		result[Modifier.color] = minimal.c;
	}
	if (minimal.b) {
		result[Modifier.background] = minimal.b;
	}
	if (minimal.a) {
		result[Modifier.link] = minimal.a;
	}
	return result;
}

const alignToNumber = {
	left: 1,
	center: 2,
	right: 3,
};

const numberToAlign = {
	1: "left",
	2: "center",
	3: "right",
};

const styleToNumber = {
	h1: 1,
	h2: 2,
	h3: 3,
	h4: 4,
	h5: 5,
	h6: 6,
};

const numberToStyle = {
	1: "h1",
	2: "h2",
	3: "h3",
	4: "h4",
	5: "h5",
	6: "h6",
};

export function minimizeBlockStyle(style: IStyle): IMinimalBlockStyle {
	const minimal: IMinimalBlockStyle = {};
	if (style[Modifier.blockquote]) {
		minimal.b = 1;
	}
	if (style[Modifier.style]) {
		const value = styleToNumber[style[Modifier.style]];
		if (value) {
			minimal.s = value;
		}
	}
	if (style[Modifier.align]) {
		minimal.a = alignToNumber[style[Modifier.align]];
	}

	return minimal;
}

export function blockStyleFromMinimize(minimal: IMinimalBlockStyle): IStyle {
	const result: IStyle = {};
	if (minimal.a) {
		result[Modifier.align] = numberToAlign[minimal.a];
	}
	if (minimal.b) {
		result[Modifier.blockquote] = true;
	}
	result[Modifier.style] = numberToStyle[minimal.s] || "p";

	return result;
}
